import { ThemeUICSSObject } from '@apia/theme';

const rollback: ThemeUICSSObject = {
  '&.selectionLabel': {
    display: 'flex',
    justifyContent: 'center',
  },
};

export default rollback;
